import Axios from "../../../Config/API";
import { IConfigRegua } from "../../../../Interfaces/Automacao/Regua/ConfiguracaoDeRegua/ConfiguracaoDeReguaInterfaces";
import Service from "../../../Service";

export async function ListarConfigReguaService() {
    return Service(
        Axios.get<Array<IConfigRegua>>(
            `/automacao/configcobrancaregua/listarconfigcobrancareguadto`
        )
    );
}

export async function CadastrarConfigReguaService(requestBody: IConfigRegua) {
    return Service(
        Axios.post(
            `/automacao/configcobrancaregua/cadastrarconfigcobrancaregua`,
            requestBody
        )
    );
}

export async function DeletarConfigReguaService(idConfigRegua: number) {
    return Service(
        Axios.delete(
            `/automacao/configcobrancaregua/deletarconfigcobrancaregua?idCasoCobrancaReguaConfig=${idConfigRegua}`
        )
    );
}

export async function AtualizarConfigReguaService(requestBody: IConfigRegua) {
    return Service(
        Axios.put(
            `/automacao/configcobrancaregua/atualizarconfigcobrancaregua`,
            requestBody
        )
    );
}

export async function EnviarSMSService(
    idCasoCobrancaReguaConfig: number,
    nrTelefone: string,
    dsMensagem: string
) {
    return Service(
        Axios.post(
            `/cobranca/sms/enviarsms?idCasoCobrancaReguaConfig=${idCasoCobrancaReguaConfig}&nrTelefone=${nrTelefone}&dsMensagem${dsMensagem}`
        )
    );
}
